const GRID_LINES = 7;

/**
 * Decorative vertical gridlines rendered behind the usage-history bars (absolutely
 * positioned, `aria-hidden`, `pointer-events-none`). Purely visual — gives the chart
 * its column rhythm; the bars stack above it via `z-10`.
 */
export function PlanBillingUsageHistoryGrid() {
    return (
        <div className="pointer-events-none absolute inset-0 flex justify-between" aria-hidden>
            {Array.from({ length: GRID_LINES }).map((_, index) => (
                // biome-ignore lint/suspicious/noArrayIndexKey: fixed-length decorative grid
                <div key={index} className="w-px bg-border opacity-80" />
            ))}
        </div>
    );
}
